import { isDateWithSingleRangeValue } from "PFCore/helpers/filters/type_checks";
import { Filters, Value } from "PFTypes";
import { useCallback } from "react";

import { WorkOpportunitiesTab } from "../constants";
import { useStartDateFilter } from "./use_start_date_filter";

export const useStartDateFilterUrlSync = () => {
  const { setStartDateCondition } = useStartDateFilter();

  return useCallback(
    (
      filtersOrValue: (Value & { fields?: any }) | Filters<Value> | null,
      tab: WorkOpportunitiesTab | null
    ) => {
      if (tab !== WorkOpportunitiesTab.MatchingRoles) {
        return;
      }

      const startDateValue = (filtersOrValue?.fields?.start_date || filtersOrValue) as Value;
      setStartDateCondition(
        isDateWithSingleRangeValue(startDateValue)
          ? { from: startDateValue.start, to: startDateValue.end }
          : null
      );
    },
    [setStartDateCondition]
  );
};
